import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["PaginationPrev"], _mergeProps({
        "data-slot": "pagination-previous",
        class: $setup.cn($setup.buttonVariants({ variant: 'ghost', size: $props.size }), 'gap-1 px-2.5 sm:pr-2.5', $setup.props.class)
    }, $setup.forwarded), {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, () => [
                _createVNode($setup["ChevronLeftIcon"]),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "hidden sm:block" }, "Previous", -1 /* CACHED */))
            ])
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
